import React, { Fragment } from 'react';
import Sticky from 'react-stickynode';
import { ThemeProvider } from 'styled-components';
import { charityTheme } from 'common/theme/charity';
import { ResetCSS } from 'common/assets/css/style';
import { DrawerProvider } from 'common/contexts/DrawerContext';
import Navbar from 'containers/Charity/Navbar';
import DrawerSection from 'containers/Charity/DrawerSection';
import BannerSection from 'containers/Charity/BannerSection';
import FeatureSection from 'containers/Charity/FeatureSection';
import BranchSection from 'containers/Charity/BranchSection';
import WorkSection from 'containers/Charity/WorkSection';
import MilestoneBlock from 'containers/Charity/MilestoneBlock';
import HumanityBlock from 'containers/Charity/HumanityBlock';
import PromotionBlock from 'containers/Charity/PromotionBlock';
import DonateSection from 'containers/Charity/DonateSection';
import MapSection from 'containers/Charity/MapSection';
import FundraiserSection from 'containers/Charity/FundraiserSection';
import BlogSection from 'containers/Charity/BlogSection';
import ClientBlock from 'containers/Charity/ClientBlock';
import Footer from 'containers/Charity/Footer';
import {
	GlobalStyle,
	CharityWrapper,
	ContentWrapper,
} from 'containers/Charity/charity.style';
import { Modal } from '@redq/reuse-modal';
import '@redq/reuse-modal/es/index.css';
import EnvatoButton from 'envato-button';
import DemoSwitcher from 'demo-switcher';
import Seo from 'components/seo';

const Charity = () => {
	return (
		<ThemeProvider theme={charityTheme}>
			<Fragment>
				<Modal />
				<Seo title="Charity" />
				<ResetCSS />
				<GlobalStyle />
				{/* Start charity wrapper section */}
				<CharityWrapper>
					<Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
						<Navbar />
					</Sticky>
					<DrawerProvider>
						<DrawerSection />
					</DrawerProvider>
					<ContentWrapper>
						<BannerSection />
						<FeatureSection />
						<BranchSection />
						<WorkSection />
						<MilestoneBlock />
						<HumanityBlock />
						<PromotionBlock />
						<DonateSection />
						<MapSection />
						<FundraiserSection />
						<BlogSection />
						<ClientBlock />
					</ContentWrapper>
					<Footer />
				</CharityWrapper>
				{/* End of charity wrapper section */}
				<DemoSwitcher />
				<EnvatoButton />
			</Fragment>
		</ThemeProvider>
	);
};
export default Charity;
